import { useQuery } from '@tanstack/react-query';
import { summaryApi } from './api';

export const summaryKeys = {
  all: ['summary'] as const,
  month: (cnpjId: string | null, month: string) =>
    ['summary', cnpjId, month] as const,
};

export function useSummary(month: string, cnpjId: string | null) {
  return useQuery({
    queryKey: summaryKeys.month(cnpjId, month),
    queryFn: () => summaryApi.get(month, cnpjId),
    enabled: !!month && !!cnpjId,
    staleTime: 30_000,
  });
}
